import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import { useFieldArray, useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { Form } from "reactstrap";
import MySelect from "../../../MyComp/UI/form/MySelect";
import { toast } from "react-toastify";
import MyButton from "../../../MyComp/UI/form/MyButton";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import { craeteHospitalAdditional } from "../../../api/master/indes";
import { StepHeader } from "./StepHeader";
import { icuNicuOptions } from "../../../assets/constants";
import { getHospitalSecondStep } from "../../../api/lab";
import useLogout from "../../../hooks/useLogout";

const HospitalStepTwo = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const mode = location?.state?.mode || "Add";

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      mode: location?.state?.mode || "Add",
      hospital: [
        {
          image: null,
          image_url: null,
        },
      ],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "hospital",
  });
  const isLoading = watch("isLoading");
  const startTime = watch("start_time");

  const yesNoOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];
const logout=useLogout()
  const selectProps = {
    register,
    watch,
    setValue,
    trigger,
    errors,
    placeholder: "Select",
    required: true,
    disabled: mode === "Approval",
  };
  const [imageOpen, setImageOpen] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  console.log(location, "location");
  const onFormSubmit = async (data) => {
    const formData = new FormData();

    formData.append("hospitalId", location?.state?.hospitalId);
    formData.append("in_house_pharmacy_service", data.in_house_pharmacy_service?.value === true);
    formData.append("diagnostic_service", data.diagnostic_service?.value === true);
    formData.append("ambulance_service", data.ambulance_service?.value === true);
    formData.append("cashLess_insurance_service", data.cashLess_insurance_service?.value === true);
    formData.append("food_service", data.food_service?.value === true);
    formData.append("icu_service", data.icu_service?.value || "");
    formData.append("start_time", data.start_time);
    formData.append("end_time", data.end_time);
    data?.hospital?.forEach((item, index) => {
      formData.append(`hospital[${index}].image`, item.image || "");
    });

        if (mode === "Add" || mode === "Edit") {
      craeteHospitalAdditional(formData).then((res) => {
        if (res?.data?.status) {
          toast.success(res.data.message);
          navigate("/hospital-list");
        }
      });
    }
  };
  console.log(location,"locationnn")
   useEffect(() => {
    if (mode === "Edit") {
      getSecondDetails();
    }
  }, [mode]);
  


const icuNicuOptions = [
  { value: "icu", label: "ICU" },
  { value: "nicu", label: "NICU" },
  { value: "both", label: "ICU + NICU" },
];
const getSecondDetails = () => {
  getHospitalSecondStep({ hospitalid: location.state.hospitalId })
    .then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;

        /** -------- SELECT FIELDS (map boolean → option) -------- */
        setValue(
          "diagnostic_service",
          yesNoOptions.find((o) => o.value === data.diagnostic_service) || null
        );

        setValue(
          "in_house_pharmacy_service",
          yesNoOptions.find((o) => o.value === data.in_house_pharmacy_service) || null
        );

        setValue(
          "ambulance_service",
          yesNoOptions.find((o) => o.value === data.ambulance_service) || null
        );

        setValue(
          "cashLess_insurance_service",
          yesNoOptions.find((o) => o.value === data.cashLess_insurance_service) || null
        );

        setValue(
          "food_service",
          yesNoOptions.find((o) => o.value === data.food_service) || null
        );

        setValue(
          "icu_service",
          icuNicuOptions.find((o) => o.value === data.icu_service) || null
        );

        /** -------- TIME -------- */
        setValue("start_time", data.start_time?.slice(0, 5) || "");
        setValue("end_time", data.end_time?.slice(0, 5) || "");

        /** -------- IMAGES (useFieldArray) -------- */
        if (data.hospitalImages?.length) {
          setValue(
            "hospital",
            data.hospitalImages.map((img) => ({
              image: null,
              image_url: img.url,
            }))
          );
        } else {
          setValue("hospital", []);
        }

     
      } 
      else if (res.data.status === "expired") {
        logout();
      }
    })
    .catch(() => {
      toast.error("Failed to fetch additional details");
    });
};


  return (
    <>
      <Head title="Hospital Registration | Additional Details" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Hospital Registration
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <PreviewAltCard>
            <StepHeader current={2} />

            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <h5 className="my-3">Additional Details</h5>

                <Col md={2}>
                  <MySelect
                    {...selectProps}
                    title="Diagnostic Service"
                    name="diagnostic_service"
                    options={yesNoOptions}
                  />
                </Col>
                <Col md={2}>
                  <MySelect
                    {...selectProps}
                    title="In-house Pharmacy Service"
                    name="in_house_pharmacy_service"
                    options={yesNoOptions}
                  />
                </Col>

                <Col md={2}>
                  <MySelect
                    {...selectProps}
                    title="Ambulance Service"
                    name="ambulance_service"
                    options={yesNoOptions}
                  />
                </Col>

                <Col md={2}>
                  <MySelect
                    {...selectProps}
                    title="ICU / NICU"
                    name="icu_service"
                    options={icuNicuOptions}
                  />
                </Col>

                <Col md={2}>
                  <MySelect
                    {...selectProps}
                    title="Cashless Insurance"
                    name="cashLess_insurance_service"
                    options={yesNoOptions}
                  />
                </Col>

                <Col md={2}>
                  <MySelect {...selectProps} title="Food Service" name="food_service" options={yesNoOptions} />
                </Col>

                <Col md={2}>
                  <label className="form-label fw-semibold">Start Time</label>
                  <input
                    type="time"
                    className="form-control"
                    {...register("start_time", {
                      required: "Start time is required",
                    })}
                  />
                  {errors.start_time && <small className="text-danger">{errors.start_time.message}</small>}
                </Col>

                <Col md={2}>
                  <label className="form-label fw-semibold">End Time</label>
                  <input
                    type="time"
                    className="form-control"
                    {...register("end_time", {
                      required: "End time is required",
                      validate: (endTime) => endTime > startTime || "End time must be after start time",
                    })}
                  />
                  {errors.end_time && <small className="text-danger">{errors.end_time.message}</small>}
                </Col>

                {fields.map((field, index) => (
                  <>
                    <Col md="2" key={field.id}>
                      {" "}
                      <ImageUpload
                        getValues={getValues}
                        id={`hospital_${index}`}
                        watch={watch}
                        trigger={trigger}
                        setError={setError}
                        clearErrors={clearErrors}
                        errors={errors}
                        register={register}
                        label={`Hospital ${index + 1}`}
                        image={`hospital.${index}.image`}
                        image_url={`hospital.${index}.image_url`}
                        setValue={setValue}
                        handleImageOpenPreview={handleImageOpenPreview}
                        // required
                        validateDoc
                        rm
                        index={index}
                        remove={remove}
                        approve={mode === "Approval" ? true : false}
                        size={2048}
                      />
                    </Col>
                  </>
                ))}
                {(watch("mode") === "Add" || watch("mode") === "Edit") && fields.length < 5 && (
                  <Col md="2">
                    <Button
                      style={{ marginTop: "30px" }}
                      type="button"
                      color="primary"
                      className=" "
                      id="addDegree"
                      onClick={() => {
                        append({ image: null, image_url: null });
                      }}
                    >
                      {"Add Hospital Image"}
                    </Button>{" "}
                  </Col>
                )}
              </Row>

              {(mode === "Add" || mode === "Edit") && (
                <Row>
                  <Col md="12" className="d-flex justify-content-end mt-4">
                    <MyButton isLoading={isLoading} mode={mode} />
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default HospitalStepTwo;
